/* Rewrites the footer review block from Yotpo's own badge.
 *
 * Yotpo injects #y-badges asynchronously and gives no callback, so this watches
 * for it rather than polling on a timer, and gives up after a while so a blocked
 * or removed app leaves the Liquid fallback in place instead of retrying forever.
 *
 * Two numbers are read:
 *   count  — from the badge image's alt text ("26716 certified reviews"), which is
 *            the exact figure. The visible .y-badge-reviews is rounded to "26.7K",
 *            so alt is the better source.
 *   rating — from the screen-reader span Yotpo writes next to its stars
 *            ("4.7 star rating").
 * Either can be missing independently, so each is applied on its own.
 */
(function () {
  'use strict';

  var GIVE_UP_AFTER_MS = 15000;

  function parseBadge(badge) {
    var out = {};

    var img = badge.querySelector('img[alt]');
    if (img) {
      // "26716 certified reviews" — first run of digits, commas tolerated.
      var countMatch = img.getAttribute('alt').replace(/,/g, '').match(/\d+/);
      if (countMatch) {
        var n = parseInt(countMatch[0], 10);
        if (n > 0) out.count = n;
      }
    }

    var srText = badge.querySelector('.sr-only');
    if (srText) {
      // "4.7 star rating"
      var ratingMatch = srText.textContent.match(/(\d+(?:\.\d+)?)/);
      if (ratingMatch) {
        var r = parseFloat(ratingMatch[1]);
        if (r > 0 && r <= 5) out.rating = r;
      }
    }

    return out;
  }

  function apply(data) {
    var root = document.querySelector('[data-nr-reviews]');
    if (!root) return;

    var countEl = root.querySelector('[data-nr-reviews-count]');
    var starsEl = root.querySelector('[data-nr-reviews-stars]');

    var shownCount = countEl ? countEl.textContent.trim() : '';
    var shownRating = null;

    if (data.count != null && countEl) {
      shownCount = data.count.toLocaleString();
      countEl.textContent = shownCount;
    }

    if (data.rating != null && starsEl) {
      shownRating = data.rating;
      // Percentage rather than whole stars, so 4.7 renders as 4.7.
      starsEl.style.setProperty('--nr-reviews-fill', (data.rating / 5) * 100 + '%');
    }

    // Rebuilt from the localised template so the announced text keeps matching
    // what is on screen. Left alone if neither number arrived.
    var template = root.getAttribute('data-nr-reviews-aria');
    if (template && (data.count != null || data.rating != null)) {
      if (shownRating == null) {
        var existing = root.getAttribute('aria-label') || '';
        var m = existing.match(/(\d+(?:\.\d+)?)/);
        shownRating = m ? m[1] : '';
      }
      root.setAttribute(
        'aria-label',
        template.replace('__RATING__', shownRating).replace('__COUNT__', shownCount)
      );
    }

    root.setAttribute('data-nr-reviews-ready', '');
  }

  function tryRead() {
    var badge = document.querySelector('#y-badges .y-badge, #y-badges img[alt]');
    if (!badge) return false;

    var data = parseBadge(document.getElementById('y-badges'));
    if (data.count == null && data.rating == null) return false;

    apply(data);
    return true;
  }

  function start() {
    if (!document.querySelector('[data-nr-reviews]')) return;

    var host = document.getElementById('y-badges');
    if (host) {
      // The badge is kept in the DOM only as a data source. It is clipped to a
      // pixel in CSS, but clipping alone still leaves it in the accessibility
      // tree, which would announce the same count and rating a second time.
      host.setAttribute('aria-hidden', 'true');
    }

    if (tryRead()) return;
    if (!host || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (tryRead()) observer.disconnect();
    });

    observer.observe(host, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, GIVE_UP_AFTER_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
